import { ApiPromiseType } from 'common/types/ApiPromiseType'
import { BlogPromiseType } from 'common/types/BlogPromiseType'
import { LayoutPromiseType } from 'common/types/LayoutPromiseType'
import { PagePromiseType } from 'common/types/PagePromiseType'
import { BlogPromise } from './BlogPromise'
import { LayoutPromise } from './LayoutPromise'
import { PagePromise } from './PagePromise'

class ApiPromiseClass implements ApiPromiseType {
  Layout: LayoutPromiseType
  Page: PagePromiseType
  Blog: BlogPromiseType
  constructor(layout: LayoutPromiseType, page: PagePromiseType, blog: BlogPromiseType) {
    this.Layout = layout
    this.Page = page
    this.Blog = blog
  }
}

export const ApiPromise = new ApiPromiseClass(LayoutPromise, PagePromise, BlogPromise)
